// szczegóły płatności
// @ts-nocheck

import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import classnames from 'classnames';

import { useGetSettlement } from 'api';

import styles from 'theme/pages/Payments/components/Details/Details.module.scss';

interface IProps {
  paymentId: number;
}

const Details: FC<IProps> = ({ paymentId }) => {
  const { data: paymentData } = useGetSettlement(paymentId, {
    enabled: typeof paymentId === 'number' && !Number.isNaN(paymentId),
  });

  return (
    <div className={classnames(styles.componentWrapper, 'StylePath-Pages-components-Details')}>
      <div>
        <div className={styles.title}>
          <Trans>Szczegóły płatności</Trans>
        </div>
        <span className={styles.label}>
          <Trans>Nazwa banku</Trans>:
        </span>{' '}
        {paymentData?.bank_name}
        <br />
        <span className={styles.label}>
          <Trans>Metoda płatności</Trans>:
        </span>{' '}
        {paymentData?.payment_name}
        <br />
        <span className={styles.label}>
          <Trans>Numer konta</Trans>:
        </span>{' '}
        {paymentData?.account}
      </div>
      <div>
        <div className={styles.title}>
          <Trans>Do zapłaty</Trans>
        </div>
        <div className={styles.price}>
          {paymentData?.balance_formatted || paymentData?.amount_formatted} {paymentData?.currency}
        </div>
      </div>
    </div>
  );
};

export default Details;
